export default __webpack_public_path__ + "static/media/community-Empty-Image.ccd42ad4.jpg";